import { MaterialIcon } from '../../../../components/Icons'


function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
const Resume = ({data: {test, location}}) => {
  return (
    <div className='bg-darkBlue rounded-lg shadow-2 items-start flex flex-col md:flex-row lg:flex-col gap-2 text-white text-sm px-3 py-4 min-w-[250px] h-min'>
      {/* <div className='flex items-center gap-1'>
        <MaterialIcon icon="vaccines" extrastyles="text-[18px]" />
        <p>{capitalize(test)}</p>
      </div> */}
      <div className='flex items-center gap-1'>
        <MaterialIcon icon="place" extrastyles="text-[18px]" />
        <p>{location}</p>
      </div>
      
    </div>
  )
}

export default Resume